import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { BookAppointmentReq, BookAppointmentRes } from './types';

export const bookAppointment = ({
  appointmentId,
  customerId,
  payload,
}: {
  appointmentId: string;
  customerId: string;
  payload: BookAppointmentReq;
}): Promise<BaseResponse<BookAppointmentRes, BookAppointmentReq>> => {
  return axios<
    BookAppointmentRes,
    BaseResponse<BookAppointmentRes, BookAppointmentReq>,
    BookAppointmentReq
  >({
    url: `/appointments/${appointmentId}/customers/${customerId}`,
    method: 'put',
    data: payload,
  });
};

export const useBookAppointment = () => {
  const { mutateAsync, error, isLoading } = useMutation(bookAppointment);

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { bookAppointment: mutateAsync, loadingBookAppointment: isLoading };
};
